import { addBackToTop, DEFAULT_SETTINGS } from '../../src/components/back_to_top/back_to_top';

addBackToTop(DEFAULT_SETTINGS);
